import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  public generalInfoDesc: string = "";

  public loader: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
